import axios from 'axios';

// Configuración base de axios
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.estudiohya.cl',
  timeout: 30000, // 30 segundos
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor de request para agregar headers si es necesario
axiosInstance.interceptors.request.use(
  (config) => {
    // Aquí puedes agregar tokens de autenticación si es necesario
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Interceptor de response para manejo centralizado de errores
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Manejo centralizado de errores
    if (error.response) {
      // El servidor respondió con un código de estado fuera del rango 2xx
      const { status, data } = error.response;

      switch (status) {
        case 400:
          console.error('Error 400: Solicitud incorrecta', data);
          break;
        case 401:
          console.error('Error 401: No autorizado', data);
          // Aquí podrías redirigir al login si es necesario
          break;
        case 403:
          console.error('Error 403: Prohibido', data);
          break;
        case 404:
          console.error('Error 404: Recurso no encontrado', data);
          break;
        case 500:
          console.error('Error 500: Error del servidor', data);
          break;
        default:
          console.error(`Error ${status}:`, data);
      }
    } else if (error.request) {
      // La solicitud se hizo pero no se recibió respuesta
      console.error('Error de red: No se recibió respuesta del servidor');
    } else {
      // Algo pasó al configurar la solicitud
      console.error('Error:', error.message);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
